export const GroupTourCards = [

    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    }
]

export const SpecialTourCards = [

    {
        location: 'special yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    },
    {
        location: 'Char Dham Yatra',
        price: '50000',
        days: '5',
        nights: '6',
        route:'Dehra Dun (1N)→Yamunotri (1N)→Gangotri (1N)→Kedarnath (1N)→Badrinath (1N)'
    }
]


